import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
    getPreferences,
    getPreference,
    clearSelectPreference,
} from 'actions/preferences/index';

import Toggle from 'material-ui/Toggle';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';

class Settings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: '',
            selected: {},
            name: '',
            textDisabled: true,
            disabled: false,
        };

        /*
        * status can be new, '', selected
        * */

        this.createNewPreference = this.createNewPreference.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
    }

    onChangeName(e, value) {
        let textDisabled = false;

        if (value.length === 0) {
            textDisabled = true;
        }

        this.setState({
            name: value,
            textDisabled,
        });
    }

    createNewPreference() {
        this.props.clearSelectPreference();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let disabled = false;

        if (nextProps.selectedType !== this.props.selectedType) {
            return this.props.clearSelectPreference();
        }

        if (nextProps.selected.userId !== this.props.userId) {
            disabled = true;
        }

        this.setState({
            selected: nextProps.selected,
            status: nextProps.selected._id ? 'selected' : 'new',
            disabled,
        })
    }

    UNSAFE_componentWillMount() {
        this.props.getPreferences({ type: 'filter' });
    }

    render() {
        const { status, name, selected, textDisabled, disabled } = this.state;
        const { preferences, sendNewPreference, selectPreference, updatePreference, deletePreference, toggleShared, selectedType } = this.props;

        let _preferences = preferences.filter((preference) => {
            return preference.filter.targetType === selectedType;
        });

        return (
            <Fragment>
                <div className='paper-block margin-10'>
                    <span className='name-block absolute small-name'>Create settings</span>

                    <div className='row'>
                        <div className='col-xs-12'>
                            <RaisedButton
                                label='create new'
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '0 10px 0 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                onClick={this.createNewPreference}
                                primary
                            />
                        </div>
                    </div>

                    {
                        status === 'new'
                            ?
                            (
                                <div className='row'>
                                    <div className='col-xs-6'>
                                        <TextField
                                            name='name of settings'
                                            hintText='Name setting'
                                            className='btn'
                                            hintStyle={{ fontSize: '12px' }}
                                            value={name}
                                            onChange={this.onChangeName}
                                            fullWidth
                                        />
                                    </div>

                                    <div className='col-xs-6'>
                                        <RaisedButton
                                            label='save to server'
                                            labelStyle={{ fontSize: '10px' }}
                                            style={{ height: '25px', margin: '0 10px 0 0' }}
                                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                            primary
                                            disabled={textDisabled}
                                            onClick={() => {
                                                sendNewPreference(name);
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                            :
                            ''
                    }
                </div>
                {
                    _preferences.length !== 0
                        ?
                        <div className='paper-block margin-10'>
                            <span className='name-block absolute small-name'>Settings</span>

                            <div className='row'>
                                <div className='col-xs-6'>
                                    <SelectField
                                        name='name of settings'
                                        hintText='Select settings'
                                        className='btn'
                                        hintStyle={{ fontSize: '12px' }}
                                        value={ selected._id ? selected._id : '' }
                                        onChange={(e, i, value) => {
                                            selectPreference(value);
                                        }}
                                        fullWidth
                                        selected
                                    >
                                        {
                                            _preferences.map((preference) => {
                                                 return (<MenuItem
                                                     key={preference._id}
                                                     value={preference._id}
                                                     primaryText={preference.name}
                                                 />)
                                            })
                                        }
                                    </SelectField>
                                </div>
                            </div>

                            {
                                status === 'selected'
                                    ?
                                    (
                                        !disabled ?
                                        <div className='row'>
                                            <div className='col-xs-3'>
                                                <RaisedButton
                                                    label='update'
                                                    primary
                                                    labelStyle={{ fontSize: '10px' }}
                                                    style={{ height: '25px', margin: '0 10px 0 0' }}
                                                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                                    onClick={() => {
                                                        updatePreference();
                                                    }}
                                                />
                                            </div>

                                            <div className='col-xs-3'>
                                                <RaisedButton
                                                    label='delete'
                                                    labelStyle={{ fontSize: '10px' }}
                                                    style={{ height: '25px', margin: '0 10px 0 0' }}
                                                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                                    secondary
                                                    onClick={() => {
                                                        deletePreference();
                                                    }}
                                                />
                                            </div>

                                            <div className='col-xs-3'>
                                                <Toggle
                                                    label='Shared'
                                                    labelStyle={{ fontSize: '12px' }}
                                                    onToggle={ toggleShared }
                                                    toggled={ selected.shared }
                                                />
                                            </div>
                                        </div>
                                            :
                                        ''
                                    )
                                    :
                                    ''
                            }
                        </div>
                        :
                        ''
                }
            </Fragment>
        );
    }
}

Settings.propTypes = {
    user: PropTypes.string,
    selectedType: PropTypes.string,
    preferences: PropTypes.array,
    sendNewPreference: PropTypes.func,
    selectPreference: PropTypes.func,
    getPreferences: PropTypes.func,
    updatePreference: PropTypes.func,
    getPreference: PropTypes.func,
    deletePreference: PropTypes.func,
    clearSelectPreference: PropTypes.func,
    toggleShared: PropTypes.func,
};

export default connect(
    ({
         preferences:
             { items: preferences, selected },
         user: { user }
     },
     { selectedType, sendNewPreference, selectPreference, updatePreference, deletePreference, toggleShared }) => {

        return {
            userId: user._id,
            selectedType,
            preferences: preferences.filter((item) => {
                return item.type === 'filter';
            }),
            selected,
            sendNewPreference,
            selectPreference,
            updatePreference,
            deletePreference,
            toggleShared,
        };
    },
    dispatch => bindActionCreators({
        getPreferences,
        getPreference,
        clearSelectPreference,
    }, dispatch),
)(Settings);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/Settings.jsx